import { useDataChange, useDataValue } from 'Simple/Data.js'
import React, { useEffect } from 'react'
import View from './view.js'

export default function Logic(props) {
  let stages = useDataValue({
    context: 'stages',
    viewPath: props.viewPath,
  })
  let selectedStage = useDataValue({
    context: 'form',
    path: 'stage_id',
    viewPath: props.viewPath,
  })
  let setSelectedStage = useDataChange({
    context: 'form',
    path: 'stage_id',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (stages.some(stage => stage.id === selectedStage)) {
      return
    }
    setSelectedStage(stages[0].id)
  }, [stages]) // eslint-disable-line

  return <View viewPath={props.viewPath} />
}
